// extracted by mini-css-extract-plugin
export default {"overview-presence__violation":"styles_overview-presence__violation__PWW0K","dropdown__section":"styles_dropdown__section__ShbiM"};